// TickerCard.tsx
// Copyright (c) 2020 Neomantra Corp

import React, { useState, useEffect } from 'react'
import { Bar, defaults } from 'react-chartjs-2'
import moment from 'moment'

type TickerCardChartProps = {
    data: any
}

const TickerCardChart = ({ data }: TickerCardChartProps) => {
    const [chartData, setChartData] = useState({}),
        [chartOptions, setChartOptions] = useState({})

    let dataReverse = [...data]
    dataReverse.reverse()

    const chart = () => {
        //ref/near/far prices, paired/imbalance shares
        let time = [],
            ref = [],
            near = [],
            far = [],
            paired = [],
            imbalance = [],
            farNotZero = false

        for (const dataObj of dataReverse) {
            const timeData = dataObj.t + (dataObj.m === 'Q' ? 14400 : 0)
            time.push(moment(timeData * 1000).format('h:mm:ss'))
            ref.push(parseFloat(dataObj.r))
            near.push(parseFloat(dataObj.n))
            far.push(parseFloat(dataObj.f))
            paired.push(parseInt(dataObj.p))
            imbalance.push(parseInt(dataObj.i))
            dataObj.f === 0 ? (farNotZero = false) : (farNotZero = true)
        }
        setChartOptions({
            maintainAspectRatio: false,
            responsive: true,
            tooltips: {
                mode: 'label',
            },
            elements: {
                line: {
                    fill: true,
                },
            },
            scales: {
                xAxes: [
                    {
                        display: true,
                        gridLines: {
                            display: false,
                        },
                        labels: time,
                    },
                ],
                yAxes: [
                    {
                        type: 'linear',
                        display: true,
                        position: 'right',
                        id: 'y-axis-1',
                        gridLines: {
                            display: false,
                        },
                        labels: {
                            show: true,
                        },
                    },
                    {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        id: 'y-axis-2',
                        gridLines: {
                            display: false,
                        },
                        labels: {
                            show: true,
                        },
                    },
                ],
            },
        })
        farNotZero
            ? setChartData({
                  datasets: [
                      {
                          label: 'near',
                          type: 'line',
                          data: near,
                          borderWidth: 1,
                          fill: false,
                          borderColor: '#3E328C',
                          backgroundColor: '#3E328C',
                          pointBorderColor: '#3E328C',
                          pointBackgroundColor: '#3E328C',
                          pointHoverBackgroundColor: '#3E328C',
                          pointHoverBorderColor: '#3E328C',
                          yAxisID: 'y-axis-2',
                          lineTension: 0.1,
                          borderCapStyle: 'butt',
                          borderDash: [],
                          borderDashOffset: 0.0,
                          borderJoinStyle: 'miter',
                          pointBorderWidth: 1,
                          pointHoverRadius: 5,
                          pointHoverBorderWidth: 2,
                          pointRadius: 1,
                          pointHitRadius: 10,
                      },
                      {
                          label: 'far',
                          type: 'line',
                          data: far,
                          borderWidth: 1,
                          fill: false,
                          borderColor: '#0979AD',
                          backgroundColor: '#0979AD',
                          pointBorderColor: '#0979AD',
                          pointBackgroundColor: '#0979AD',
                          pointHoverBackgroundColor: '#0979AD',
                          pointHoverBorderColor: '#0979AD',
                          yAxisID: 'y-axis-2',
                          lineTension: 0.1,
                          borderCapStyle: 'butt',
                          borderDash: [],
                          borderDashOffset: 0.0,
                          borderJoinStyle: 'miter',
                          pointBorderWidth: 1,
                          pointHoverRadius: 5,
                          pointHoverBorderWidth: 2,
                          pointRadius: 1,
                          pointHitRadius: 10,
                      },
                      {
                          label: 'ref',
                          type: 'line',
                          data: ref,
                          borderWidth: 1,
                          fill: false,
                          borderColor: '#958ABF',
                          backgroundColor: '#958ABF',
                          pointBorderColor: '#958ABF',
                          pointBackgroundColor: '#958ABF',
                          pointHoverBackgroundColor: '#958ABF',
                          pointHoverBorderColor: '#958ABF',
                          yAxisID: 'y-axis-2',
                          lineTension: 0.1,
                          borderCapStyle: 'butt',
                          borderDash: [],
                          borderDashOffset: 0.0,
                          borderJoinStyle: 'miter',
                          pointBorderWidth: 1,
                          pointHoverRadius: 5,
                          pointHoverBorderWidth: 2,
                          pointRadius: 1,
                          pointHitRadius: 10,
                      },
                      {
                          label: 'paired',
                          type: 'bar',
                          data: paired,
                          borderWidth: 1,
                          fill: false,
                          borderColor: '#9CD3D9',
                          backgroundColor: '#9CD3D9',
                          pointBorderColor: '#9CD3D9',
                          pointBackgroundColor: '#9CD3D9',
                          pointHoverBackgroundColor: '#9CD3D9',
                          pointHoverBorderColor: '#9CD3D9',
                          yAxisID: 'y-axis-1',
                      },
                      {
                          label: 'imbalance',
                          type: 'bar',
                          data: imbalance,
                          borderWidth: 1,
                          fill: false,
                          borderColor: '#F2B5A7',
                          backgroundColor: '#F2B5A7',
                          pointBorderColor: '#F2B5A7',
                          pointBackgroundColor: '#F2B5A7',
                          pointHoverBackgroundColor: '#F2B5A7',
                          pointHoverBorderColor: '#F2B5A7',
                          yAxisID: 'y-axis-1',
                      },
                  ],
              })
            : setChartData({
                  datasets: [
                      {
                          label: 'near',
                          type: 'line',
                          data: near,
                          borderWidth: 1,
                          fill: false,
                          borderColor: '#3E328C',
                          backgroundColor: '#3E328C',
                          pointBorderColor: '#3E328C',
                          pointBackgroundColor: '#3E328C',
                          pointHoverBackgroundColor: '#3E328C',
                          pointHoverBorderColor: '#3E328C',
                          yAxisID: 'y-axis-2',
                          lineTension: 0.1,
                          borderCapStyle: 'butt',
                          borderDash: [],
                          borderDashOffset: 0.0,
                          borderJoinStyle: 'miter',
                          pointBorderWidth: 1,
                          pointHoverRadius: 5,
                          pointHoverBorderWidth: 2,
                          pointRadius: 1,
                          pointHitRadius: 10,
                      },
                      {
                          label: 'ref',
                          type: 'line',
                          data: ref,
                          borderWidth: 1,
                          fill: false,
                          borderColor: '#958ABF',
                          backgroundColor: '#958ABF',
                          pointBorderColor: '#958ABF',
                          pointBackgroundColor: '#958ABF',
                          pointHoverBackgroundColor: '#958ABF',
                          pointHoverBorderColor: '#958ABF',
                          yAxisID: 'y-axis-2',
                          lineTension: 0.1,
                          borderCapStyle: 'butt',
                          borderDash: [],
                          borderDashOffset: 0.0,
                          borderJoinStyle: 'miter',
                          pointBorderWidth: 1,
                          pointHoverRadius: 5,
                          pointHoverBorderWidth: 2,
                          pointRadius: 1,
                          pointHitRadius: 10,
                      },
                      {
                          label: 'paired',
                          type: 'bar',
                          data: paired,
                          borderWidth: 1,
                          fill: false,
                          borderColor: '#9CD3D9',
                          backgroundColor: '#9CD3D9',
                          pointBorderColor: '#9CD3D9',
                          pointBackgroundColor: '#9CD3D9',
                          pointHoverBackgroundColor: '#9CD3D9',
                          pointHoverBorderColor: '#9CD3D9',
                          yAxisID: 'y-axis-1',
                      },
                      {
                          label: 'imbalance',
                          type: 'bar',
                          data: imbalance,
                          borderWidth: 1,
                          fill: false,
                          borderColor: '#F2B5A7',
                          backgroundColor: '#F2B5A7',
                          pointBorderColor: '#F2B5A7',
                          pointBackgroundColor: '#F2B5A7',
                          pointHoverBackgroundColor: '#F2B5A7',
                          pointHoverBorderColor: '#F2B5A7',
                          yAxisID: 'y-axis-1',
                      },
                  ],
              })
    }

    useEffect(() => {
        defaults.global.animation = false
    }, [])

    useEffect(() => {
        //console.log(`data = `, data)
        chart()
    }, [data])

    const legendOpts = {
        display: true,
        position: 'bottom',
        fullWidth: true,
        reverse: false,
    }

    return (
        <div style={{ height: 200 }}>
            <Bar data={chartData} options={chartOptions} legend={legendOpts} />
        </div>
    )
}

export default TickerCardChart
